const emailField = document.querySelector(".newsletter__text-input");
const emailButton = document.querySelector(".newsletter__button");
const errorMsg = document.querySelector(".newsletter__error-message");

function newsletterValidation() {
    if (emailButton) {
        emailButton.addEventListener('click', function(e) {
            let response = validateEmail(emailField.value);
            if (!response.status) {
                e.preventDefault();  
                errorMsg.innerHTML = response.errMsg;
                emailField.style.borderColor = "red"; 
            } else {
                errorMsg.innerHTML = "";
                emailField.style.borderColor = "";
            }
        }, false);
    }
    if (emailField) {
        emailField.addEventListener('keyup', function(e) {
            errorMsg.innerHTML = "";
            emailField.style.borderColor = "";
        });
    }
};

function validateEmail(email) {
    if (email.length === 0) {
        return {status: false, errMsg: "Value cannot be empty"};
    }
    const regexPattern = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    return {status: regexPattern.test(String(email).toLowerCase()), errMsg: "Value must be a valid email address"};
}

export default newsletterValidation;